module.exports = __webpack_public_path__ + "fonts/euclid-square-500.c10736c0.ttf";